import { render, staticRenderFns } from "./CustomerAuditTrailHistory.vue?vue&type=template&id=00a185ba"
import script from "./CustomerAuditTrailHistory.vue?vue&type=script&lang=js"
export * from "./CustomerAuditTrailHistory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports